// Mock data for LTR Capital Partners
// NOTE: All data below is MOCKED for the frontend-only build. It will be replaced
// with real backend data once backend integration is approved.

export const company = {
  name: "LTR Capital Partners",
  tagline: "Your Partner In Real Estate Investment",
  phoneDisplay: "(844) LENDER1",
  phoneTel: "8445363371",
  email: "loans@lendingtradecenter.com",
  hours: "Mon–Fri 9am–6pm ET",
  address: "Nationwide Commercial Lending · United States",
  maxLoan: "$100 Million",
};

export const heroStats = [
  { value: "$100M", label: "Max Loan Amount" },
  { value: "72 hrs", label: "Funding Speed" },
  { value: "85%", label: "LTV Available" },
  { value: "20+ yrs", label: "Lending Experience" },
];

export const heroImages = {
  skyline:
    "https://images.unsplash.com/photo-1719422244246-93f887d610fc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  skylineAlt:
    "https://images.unsplash.com/photo-1781433866816-415b72607d81?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  handshake:
    "https://images.unsplash.com/photo-1638262052640-82e94d64664a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  meeting:
    "https://images.unsplash.com/photo-1573164574572-cb89e39749b4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  meeting2:
    "https://images.unsplash.com/photo-1517048676732-d65bc937f952?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const loanPrograms = [
  {
    slug: "commercial-real-estate",
    title: "Commercial Real Estate Financing",
    short: "Loans for commercial construction, property purchase, and refinancing with some of the lowest mortgage rates in the market.",
    image:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=900&auto=format&fit=crop",
    highlights: ["Purchase, refinance & construction", "Loan amounts up to $100M", "Competitive fixed & adjustable rates"],
    body: "Our team is committed to providing business real estate loans for commercial construction, property purchase, and refinancing — combined with some of the lowest mortgage rates available. We finance office, retail, industrial, mixed-use and special-purpose properties nationwide.",
    facts: [{ k: "Loan Amount", v: "Up to $100M" }, { k: "Max LTV", v: "Up to 80%" }, { k: "Term", v: "5 – 30 years" }, { k: "Rate Type", v: "Fixed / ARM" }],
  },
  {
    slug: "sba-loans",
    title: "SBA Loans",
    short: "Government-backed programs to help small business owners start, manage, and grow their businesses.",
    image:
      "https://images.unsplash.com/photo-1556740758-90de374c12ad?q=80&w=900&auto=format&fit=crop",
    highlights: ["SBA 7(a) & 504 programs", "Low down payments", "Longer repayment terms"],
    body: "The SBA offers numerous loan programs to assist small business owners to start, manage and grow their businesses. An SBA loan is a small business loan that is partly guaranteed by the U.S. government (the Small Business Administration), reducing lender risk and unlocking better terms for you.",
    facts: [{ k: "Loan Amount", v: "$50K – $5M" }, { k: "Down Payment", v: "As low as 10%" }, { k: "Term", v: "Up to 25 years" }, { k: "Guarantee", v: "SBA backed" }],
  },
  {
    slug: "fix-n-flip-loans",
    title: "Fix N Flip Loans",
    short: "Short-term financing to fund the purchase and rehab of investment properties — as easy as 1, 2, 3.",
    image:
      "https://images.unsplash.com/photo-1517581177682-a085bb7ffb15?q=80&w=900&auto=format&fit=crop",
    highlights: ["Purchase + rehab funding", "Fast draws for renovations", "Interest-only options"],
    body: "Looking to purchase and rehab an investment property? We are your go-to short-term financing solution provider to fund the purchase and repairs of an investment property. We make the funding as easy as 1, 2, 3 with quick closings and flexible draw schedules.",
    facts: [{ k: "Loan Amount", v: "$75K – $5M" }, { k: "Max LTV/ARV", v: "Up to 90% / 75%" }, { k: "Term", v: "6 – 24 months" }, { k: "Closing", v: "As fast as 5 days" }],
  },
  {
    slug: "working-capital-loans",
    title: "Working Capital Loans",
    short: "Unsecured funding for inventory, payroll, marketing and taxes — no collateral required under $725,000.",
    image:
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72?q=80&w=900&auto=format&fit=crop",
    highlights: ["No collateral under $725K", "Fast approvals", "Flexible use of funds"],
    body: "With our Working Capital Loans, we've helped thousands of businesses. Our Working Capital Loan is an unsecured debt, requiring no collateral for amounts under $725,000 — unlike traditional bank loans. Use funds for inventory, payroll, marketing, taxes and more.",
    facts: [{ k: "Loan Amount", v: "$10K – $725K" }, { k: "Collateral", v: "None under $725K" }, { k: "Term", v: "3 – 24 months" }, { k: "Funding", v: "72 hours or less" }],
  },
  {
    slug: "hard-money-loans",
    title: "Hard Money Loans",
    short: "Asset-based short-term financing — receive up to 75% of the value of your purchase.",
    image:
      "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?q=80&w=900&auto=format&fit=crop",
    highlights: ["Asset-based lending", "Up to 75% of value", "Close when banks say no"],
    body: "Hard money loans are designed to be short-term loans and have loan amounts that are typically higher than conventional loans. Typically, you can receive up to 75% of the value of your purchase with hard money. Our reputation as a private money lender is built on speed and reliability.",
    facts: [{ k: "Loan Amount", v: "$100K – $25M" }, { k: "Max LTV", v: "Up to 75%" }, { k: "Term", v: "6 – 36 months" }, { k: "Basis", v: "Asset value" }],
  },
  {
    slug: "apartment-loans",
    title: "Apartment Loans",
    short: "Financing for apartment buildings, condominiums, and multifamily complexes — up to 85% of value.",
    image:
      "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?q=80&w=900&auto=format&fit=crop",
    highlights: ["5+ unit multifamily", "Up to 85% financing", "Purchase & refinance"],
    body: "Planning to purchase an apartment building, a condominium or any multifamily residential complex? In most cases, we can get a multifamily loan approved for you for 85% of the total value of the property, with competitive terms for both purchase and refinance.",
    facts: [{ k: "Loan Amount", v: "$500K – $100M" }, { k: "Max LTV", v: "Up to 85%" }, { k: "Term", v: "5 – 30 years" }, { k: "Units", v: "5+ units" }],
  },
  {
    slug: "bridge-loans",
    title: "Bridge Loans",
    short: "Short-term interim financing that bridges the gap between one loan and a permanent long-term loan.",
    image:
      "https://images.unsplash.com/photo-1535732759880-bbd5c7265e3f?q=80&w=900&auto=format&fit=crop",
    highlights: ["Interim financing", "Fast closings", "Flexible exit strategies"],
    body: "Short-term mortgage financing that is in place between the termination of one loan and the beginning of another. Also a form of interim loan, generally made between a short-term loan and a permanent (long-term) loan — perfect for time-sensitive acquisitions and repositioning.",
    facts: [{ k: "Loan Amount", v: "$250K – $50M" }, { k: "Max LTV", v: "Up to 80%" }, { k: "Term", v: "6 – 36 months" }, { k: "Closing", v: "7 – 14 days" }],
  },
  {
    slug: "equipment-financing",
    title: "Equipment Financing",
    short: "Fund new and expensive equipment quickly, so your business can keep moving forward.",
    image:
      "https://images.unsplash.com/photo-1495036019936-220b29b930ea?q=80&w=900&auto=format&fit=crop",
    highlights: ["New & used equipment", "Fast approvals", "Lease or finance"],
    body: "Buying equipment becomes urgent as businesses strive to move forward. We understand the difficulty people run into when the need for additional equipment becomes urgent. Purchasing new and expensive equipment for your business shouldn't slow you down — we make it fast and affordable.",
    facts: [{ k: "Loan Amount", v: "$25K – $10M" }, { k: "Financing", v: "Up to 100%" }, { k: "Term", v: "2 – 7 years" }, { k: "Type", v: "Lease / Finance" }],
  },
];

// Residential mortgage products (added alongside our commercial services)
export const residentialPrograms = [
  {
    slug: "fha-loans",
    title: "FHA Loans",
    short: "As little as 3.5% down with credit scores down to 580 — ideal for first-time and returning buyers.",
    image:
      "https://images.unsplash.com/photo-1628624747186-a941c476b7ef?q=80&w=900&auto=format&fit=crop",
    highlights: ["As little as 3.5% down", "Credit scores down to 580", "Up to 6% seller-paid closing costs"],
    body: "FHA loans are government-insured mortgages that make homeownership accessible with lower down payments and more flexible credit requirements. Put as little as 3.5% down, qualify with credit scores down to 580, and let sellers contribute up to 6% toward your closing costs.",
    facts: [{ k: "Down Payment", v: "As low as 3.5%" }, { k: "Min Credit", v: "580" }, { k: "Term", v: "15 / 30 years" }, { k: "Mortgage Insurance", v: "Required" }],
  },
  {
    slug: "va-loans",
    title: "VA Loans",
    short: "$0 down for veterans and active military, with no monthly mortgage insurance.",
    image:
      "https://images.unsplash.com/photo-1570129477492-45c003edd2be?q=80&w=900&auto=format&fit=crop",
    highlights: ["$0 down payment", "No monthly mortgage insurance", "No loan limit for full entitlement"],
    body: "VA loans are a benefit earned by veterans, active-duty service members, and eligible spouses. Enjoy $0 down payment, no monthly mortgage insurance, competitive rates, and no loan limit with full entitlement — one of the most powerful home financing tools available.",
    facts: [{ k: "Down Payment", v: "$0" }, { k: "Mortgage Insurance", v: "None" }, { k: "Term", v: "15 / 30 years" }, { k: "Eligibility", v: "Military / Veteran" }],
  },
  {
    slug: "usda-loans",
    title: "USDA Loans",
    short: "$0 down rural development mortgages with a low 0.35% annual fee across eligible areas.",
    image:
      "https://images.unsplash.com/photo-1628652462669-6835a3090864?q=80&w=900&auto=format&fit=crop",
    highlights: ["$0 down payment", "Low 0.35% annual fee", "Wide rural eligibility"],
    body: "USDA loans help buyers purchase homes in eligible rural and suburban areas with $0 down and a low 0.35% annual fee. A large share of the country's geography qualifies, making this an affordable path to homeownership outside major metros.",
    facts: [{ k: "Down Payment", v: "$0" }, { k: "Annual Fee", v: "0.35%" }, { k: "Term", v: "30 years" }, { k: "Area", v: "Rural / Suburban" }],
  },
  {
    slug: "conventional-loans",
    title: "Conventional Loans",
    short: "Flexible fixed and adjustable-rate mortgages with as little as 3% down for qualified buyers.",
    image:
      "https://images.unsplash.com/photo-1583608205776-bfd35f0d9f83?q=80&w=900&auto=format&fit=crop",
    highlights: ["As low as 3% down", "PMI drops off at 20% equity", "Fixed & adjustable options"],
    body: "Conventional loans are the most common mortgage type, offering competitive rates and flexible terms for buyers with solid credit. Put as little as 3% down, cancel private mortgage insurance once you reach 20% equity, and choose from fixed or adjustable-rate structures.",
    facts: [{ k: "Down Payment", v: "As low as 3%" }, { k: "Min Credit", v: "620" }, { k: "Term", v: "10 – 30 years" }, { k: "Rate Type", v: "Fixed / ARM" }],
  },
  {
    slug: "jumbo-loans",
    title: "Jumbo Loans",
    short: "Financing for high-value and luxury homes above conforming loan limits.",
    image:
      "https://images.unsplash.com/photo-1706808849780-7a04fbac83ef?q=80&w=900&auto=format&fit=crop",
    highlights: ["Loan amounts above conforming limits", "Competitive luxury-home rates", "Flexible documentation"],
    body: "Jumbo loans finance high-value properties that exceed conforming loan limits. Whether you're purchasing a luxury primary residence or a high-end second home, we offer competitive rates and flexible qualification options tailored to premium buyers.",
    facts: [{ k: "Loan Amount", v: "Above $806K+" }, { k: "Down Payment", v: "From 10%" }, { k: "Term", v: "15 / 30 years" }, { k: "Rate Type", v: "Fixed / ARM" }],
  },
  {
    slug: "manufactured-home-loans",
    title: "Manufactured Home Loans",
    short: "Financing for singlewides & doublewides — FHA, VA, USDA, and conventional options available.",
    image:
      "https://images.unsplash.com/photo-1713948898788-547426f32abc?q=80&w=900&auto=format&fit=crop",
    highlights: ["Singlewides & doublewides", "FHA, VA, USDA & conventional", "Back to 1976 models"],
    body: "Manufactured and mobile homes are a smart, affordable path to ownership. We finance singlewides and doublewides going back to 1976 across FHA, VA, USDA, and conventional programs — with the same care and speed we bring to every loan.",
    facts: [{ k: "Home Types", v: "Single / Double" }, { k: "Programs", v: "FHA/VA/USDA/Conv" }, { k: "Year Built", v: "1976 or newer" }, { k: "Down Payment", v: "As low as 3.5%" }],
  },
  {
    slug: "refinance",
    title: "Refinance",
    short: "Lower your rate, tap your equity, or skip the appraisal with streamline options.",
    image:
      "https://images.unsplash.com/photo-1741156386380-0236c72eb6f9?q=80&w=900&auto=format&fit=crop",
    highlights: ["Rate & term refinance", "Cash-out & HELOC options", "FHA/VA/USDA streamlines"],
    body: "Refinancing can lower your monthly payment, shorten your term, or unlock your home's equity for cash. Choose from rate-and-term refinances, cash-out options, or fast FHA, VA, and USDA streamline refinances — often with reduced documentation and no appraisal.",
    facts: [{ k: "Options", v: "Rate/Term, Cash-out" }, { k: "Streamlines", v: "FHA/VA/USDA" }, { k: "Appraisal", v: "May be waived" }, { k: "Closing", v: "14 – 21 days" }],
  },
];

// Combined list for detail-page lookups
export const allPrograms = [...loanPrograms, ...residentialPrograms];

export const processSteps = [
  { num: "01", title: "Apply Online", desc: "No obligation, FREE consultation. Tell us about your scenario in our quick online form." },
  { num: "02", title: "Quick Processing", desc: "Every application is processed on priority by our experienced underwriting team." },
  { num: "03", title: "Get Funded", desc: "Receive your funds within 72 hours or even less once approved." },
];

export const propertyTypes = [
  { name: "Apartment / Multi-family", note: "5–20 Units, 21+ Units" },
  { name: "Retail Properties", note: "Store, Clothing, Electronics" },
  { name: "Hotels & Motels", note: "Hospitality financing" },
  { name: "Health Care Facilities", note: "Assisted Living, Hospital" },
  { name: "Industrial Buildings", note: "Manufacturing, Warehouse" },
  { name: "Office Buildings", note: "Business Condos, High Rise" },
  { name: "Gym / Health Club", note: "Fitness center financing" },
  { name: "Construction", note: "New & Renovation" },
  { name: "Special Use Properties", note: "Car wash, Ice cream shop" },
  { name: "Auto (Real Estate)", note: "Dealerships, Parking Garages" },
  { name: "Medical", note: "Clinic, Rehabilitation Center" },
  { name: "More Properties", note: "Church, Historic Rehabs" },
];

export const whyUs = [
  { title: "Speed", desc: "Fast approvals and funding within 72 hours. We move as quickly as your deal demands." },
  { title: "Reliability", desc: "Our reputation as a hard money / private money lender is built on delivering when it counts." },
  { title: "More Programs", desc: "Commercial, SBA, fix-n-flip, bridge, apartment, equipment and more — the right tool for every scenario." },
];

export const stats = [
  { value: "20+", label: "Years Experience" },
  { value: "$2B+", label: "Funded to Date" },
  { value: "50", label: "States Served" },
  { value: "5,000+", label: "Businesses Helped" },
];

export const testimonials = [
  { initials: "MR", name: "Marcus Reed", role: "Multifamily Investor, TX", text: "LTR Capital closed my 24-unit apartment acquisition in under three weeks when two banks had already turned me down. Professional, fast, and true to their word." },
  { initials: "SD", name: "Sofia Delgado", role: "Fix & Flip Investor, FL", text: "The fix-n-flip program was exactly what I needed. Draws were fast and my rep was reachable at every step. I'm already on my third project with them." },
  { initials: "JT", name: "James Thornton", role: "Retail Owner, GA", text: "I needed working capital fast for inventory. No collateral, no headaches — funded in two days. Highly recommend LTR Capital Partners." },
  { initials: "AH", name: "Aisha Hassan", role: "Healthcare Facility Owner, NY", text: "They understood my special-use property when nobody else would. Great communication and a smooth close. A genuine lending partner." },
];

export const blogPosts = [
  { date: "July 24, 2025", title: "How to Structure a Commercial Real Estate Refinance in 2025", excerpt: "Rate strategy, cash-out limits, and the underwriting metrics lenders care about most this year." },
  { date: "July 17, 2025", title: "Hard Money vs. Bridge Loans: Which Is Right for You?", excerpt: "A plain-English breakdown of when speed, leverage, and exit strategy should drive your choice." },
  { date: "July 10, 2025", title: "5 Things That Speed Up Your Fix-N-Flip Approval", excerpt: "From ARV documentation to contractor bids — the file details that get you funded faster." },
];

// ---------------- Tools & Guides (Resources) ----------------
export const toolsGuides = [
  {
    slug: "borrowers-guide",
    icon: "BookOpen",
    title: "Borrower's Guide",
    desc: "A complete walkthrough of the financing process — from application to funding. Free PDF-style guide.",
    cta: "Read the Guide",
  },
  {
    slug: "glossary",
    icon: "Library",
    title: "Lending Glossary",
    desc: "Key commercial and residential lending terms defined in plain English. Quick reference for LTV, DSCR, escrow and more.",
    cta: "Browse Terms",
  },
  {
    slug: "documents",
    icon: "FileCheck",
    title: "Documents Needed",
    desc: "A complete checklist of documents needed for your loan — organized by category and by loan type.",
    cta: "View Checklist",
  },
  {
    slug: "calculators",
    icon: "Calculator",
    title: "Calculators",
    desc: "Estimate your monthly payment, model an amortization schedule, and compare loan scenarios.",
    cta: "Browse Tools",
  },
];

export const glossary = [
  { term: "Amortization", def: "The process of paying off a loan through regular payments of principal and interest over time." },
  { term: "APR (Annual Percentage Rate)", def: "The yearly cost of a loan including interest and fees, expressed as a percentage — useful for comparing offers." },
  { term: "ARV (After-Repair Value)", def: "The estimated value of a property after renovations are completed, used heavily in fix-and-flip lending." },
  { term: "Balloon Payment", def: "A large lump-sum payment due at the end of certain loans after smaller periodic payments." },
  { term: "Bridge Loan", def: "Short-term interim financing used to 'bridge' the gap until permanent financing or a sale is secured." },
  { term: "Cap Rate", def: "Net operating income divided by property value — a key measure of a commercial property's return." },
  { term: "Closing Costs", def: "Fees and expenses paid at the completion of a real estate transaction, separate from the down payment." },
  { term: "DSCR (Debt-Service Coverage Ratio)", def: "Net operating income divided by total debt service; lenders use it to gauge a property's ability to cover its loan." },
  { term: "Debt-to-Income (DTI)", def: "The percentage of gross monthly income that goes toward debt payments — a core residential underwriting metric." },
  { term: "Equity", def: "The portion of a property's value that the owner truly owns, calculated as value minus outstanding loan balance." },
  { term: "Escrow", def: "An account held by a third party to manage funds such as taxes and insurance on behalf of a borrower." },
  { term: "Hard Money Loan", def: "An asset-based short-term loan secured primarily by the value of real estate rather than borrower credit." },
  { term: "Interest-Only Loan", def: "A loan where payments cover only interest for a set period, keeping early payments lower." },
  { term: "Jumbo Loan", def: "A mortgage that exceeds conforming loan limits, typically used for high-value properties." },
  { term: "LTV (Loan-to-Value)", def: "The loan amount divided by the property's value — a primary measure of lending risk." },
  { term: "Origination Fee", def: "A fee charged by a lender to process and originate a new loan, usually a percentage of the amount." },
  { term: "PMI (Private Mortgage Insurance)", def: "Insurance required on many conventional loans with less than 20% down; it protects the lender." },
  { term: "Points", def: "Upfront fees paid to a lender at closing, where one point equals 1% of the loan amount, often to lower the rate." },
  { term: "Prepayment Penalty", def: "A fee some loans charge if the borrower pays off the balance earlier than scheduled." },
  { term: "Refinance", def: "Replacing an existing loan with a new one — often to lower the rate, change the term, or take cash out." },
  { term: "Term Sheet", def: "A non-binding document outlining the proposed terms and conditions of a loan before final approval." },
  { term: "Underwriting", def: "The lender's process of evaluating risk and verifying a borrower and property before approving a loan." },
];

export const documentsChecklist = [
  {
    category: "Personal & Identity",
    items: ["Government-issued photo ID", "Social Security number / EIN", "Contact information & current address"],
  },
  {
    category: "Income & Financials",
    items: ["Last 2 years personal & business tax returns", "Recent pay stubs (residential)", "Year-to-date profit & loss statement (business)", "2–3 months of bank statements"],
  },
  {
    category: "Property & Deal",
    items: ["Purchase contract or LOI", "Rent roll & leases (income property)", "Property appraisal or valuation", "Renovation budget / scope of work (fix-n-flip)"],
  },
  {
    category: "Entity (Commercial)",
    items: ["Articles of organization / incorporation", "Operating agreement or bylaws", "Business license", "Certificate of good standing"],
  },
];

export const buyerGuideSteps = [
  { step: "1", title: "Get Pre-Qualified", desc: "Complete our quick, no-obligation form so we can understand your scenario and match you to the right program." },
  { step: "2", title: "Gather Your Documents", desc: "Use our Documents Needed checklist to prepare income, property, and entity paperwork for a smooth review." },
  { step: "3", title: "Review Loan Options", desc: "We shop your scenario and present competitive options with clear terms, rates, and closing costs." },
  { step: "4", title: "Underwriting & Approval", desc: "Our team processes your file on priority — most approvals move quickly once documents are in." },
  { step: "5", title: "Close & Get Funded", desc: "Sign your final documents and receive your funds — commercial deals can fund in as little as 72 hours." },
];

// ---------------- Personal Loans (partner: Lendvious) ----------------
export const PERSONAL_LOAN_URL =
  "https://www.lendvious.com/gateway-public/lendvious/create-loan/CONSUMER?o=ltrlending";

export const personalLoan = {
  image:
    "https://images.unsplash.com/photo-1758691031730-640885ad19e5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  imageAlt:
    "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  stats: [
    { value: "$50K", label: "Up to" },
    { value: "60 sec", label: "Rate check" },
    { value: "$0", label: "To apply" },
    { value: "No", label: "Impact to check*" },
  ],
  uses: [
    "Debt & credit card consolidation",
    "Home improvement projects",
    "Medical or dental expenses",
    "Major purchases & moving costs",
    "Weddings & special events",
    "Unexpected emergencies",
  ],
  features: [
    { title: "Fast Rate Check", desc: "See personalized rates in about a minute — checking your rate won't affect your credit score.*" },
    { title: "Fixed Monthly Payments", desc: "Simple, predictable payments with no prepayment penalties and no surprises." },
    { title: "Unsecured — No Collateral", desc: "Personal loans require no home, car, or other asset as collateral." },
    { title: "One Simple Form", desc: "Compare offers from a network of trusted lenders through a single quick application." },
  ],
};
